import { DateTime } from "luxon";

export const getScheduledDateTime = (
    date: Date,
    time: { hour: number; minute: number },
    period: string,
    timeZone: string // User's IANA timezone string
): string => {
    // Convert 12-hour time to 24-hour format
    const hours24 =
        period === "PM" && time.hour !== 12
            ? time.hour + 12
            : period === "AM" && time.hour === 12
            ? 0
            : time.hour;

    // Create a Luxon DateTime object in the user's timezone
    const scheduledDateTime = DateTime.fromObject(
        {
            year: date.getFullYear(),
            month: date.getMonth() + 1, // Luxon months are 1-based
            day: date.getDate(),
            hour: hours24,
            minute: time.minute,
            second: 0,
            millisecond: 0,
        },
        { zone: timeZone }
    );

    const scheduledDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        hours24,
        time.minute,
        0,
        0
    );

    return scheduledDateTime.toUTC().toISO() || scheduledDate.toISOString();
};

/** The date and time, read in the profile time zone as the send time is, are not in the future. */
export const isPastInZone = (
    date: Date,
    time: { hour: number; minute: number },
    period: string,
    timeZone: string,
    now: Date = new Date()
): boolean => new Date(getScheduledDateTime(date, time, period, timeZone)) <= now;

/** A copy of the date moved forward a day at a time until the time on it is in the future (profile time zone). */
export const rollToFuture = (
    date: Date,
    time: { hour: number; minute: number },
    period: string,
    timeZone: string,
    now: Date = new Date()
): Date => {
    const next = new Date(date);
    // At most three days: the browser's date can trail the profile's by two (UTC-12 against UTC+14).
    for (let i = 0; i < 3 && isPastInZone(next, time, period, timeZone, now); i++) {
        next.setDate(next.getDate() + 1);
    }
    return next;
};
